import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { CandidateEventsForOrderGQL, CreateOrderClientContactedGQL, CreateOrderErrorGQL, GetOrderErrorCategoriesGQL } from 'src/generated/graphql';
import { BehaviorSubject, Observable } from 'rxjs';
import { RelayIdService } from '../shared/relay-id.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  isIndefiniteSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private relayIdService: RelayIdService,
    private orderCandidateGQL: CandidateEventsForOrderGQL,
    private createOrderClientContactedGQL: CreateOrderClientContactedGQL,
    private getOrderErrorCategoriesGQL: GetOrderErrorCategoriesGQL,
    private createOrderErrorGQL: CreateOrderErrorGQL
  ) { }

  private getReminderUrl(id) {
    const parsed = this.relayIdService.parseId(id);
    return `${environment.url}/api/v1/orders/${parsed}/signing-reminder/`;
  }

  getReminder(id) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http.get(this.getReminderUrl(id), {headers});
  }

  createReminder(id, days) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http.post<ReminderAPI>(this.getReminderUrl(id), {interval_days: days}, {headers});
  }

  updateReminder(id, days) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http.patch<ReminderAPI>(this.getReminderUrl(id), {interval_days: days}, {headers});
  }

  deleteReminder(id) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http.delete(this.getReminderUrl(id), {headers});
  }


  downloadContract(orderId) {
    const url = `${environment.url}/api/v1/orders/${orderId}/document/`;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token')}`
    });

    return this.http.get(url, {headers, responseType: 'blob'});
  }

  getOrderCandidates(orderId, eventType) {
    return this.orderCandidateGQL.watch({orderId, eventType}, {fetchPolicy: 'cache-and-network'}).valueChanges;
  }

  createOrderClientContacted(orderId: string, date: string): Observable<any> {
    return this.createOrderClientContactedGQL.mutate({ order: orderId, date });
  }

  getOrderErrorCategories() {
    return this.getOrderErrorCategoriesGQL.fetch({ isActive: true });
  }

  createOrderError(orderId: string, categoryId: string, comment: string) {
    return this.createOrderErrorGQL.mutate({ order: orderId, category: categoryId, comment });
  }
}

export interface ReminderAPI {
  created_at: string;
  id: number;
  interval_days: number;
  is_active: boolean;
  last_sent_at: string;
  next_send_at: string;
  reminder_kind: string;
  updated_at: string;
}
